var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,0H5C2.243,0,0,2.243,0,5v14c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V5c0-2.757-2.243-5-5-5Zm3,19c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V5c0-.352,.072-.686,.184-1H21.816c.112,.314,.184,.648,.184,1v14ZM4,8c0-.552,.447-1,1-1h3c.553,0,1,.448,1,1s-.447,1-1,1h-3c-.553,0-1-.448-1-1Zm10,5c0,.553-.447,1-1,1H7c-.553,0-1-.447-1-1s.447-1,1-1h6c.553,0,1,.448,1,1Zm0,5c0,.553-.447,1-1,1H5c-.553,0-1-.447-1-1s.447-1,1-1H13c.553,0,1,.447,1,1Zm6,0c0,1.105-.895,2-2,2s-2-.895-2-2c0-.738,.405-1.376,1-1.723v-6.277c0-.551-.448-1-1-1h-1.277c-.346,.595-.984,1-1.723,1-1.105,0-2-.895-2-2s.895-2,2-2c.738,0,1.376,.405,1.723,1h1.277c1.654,0,3,1.346,3,3v6.277c.595,.346,1,.984,1,1.723Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterPlan);
export default __webpack_public_path__ + "static/media/master-plan.295d6f604d23bbee88bedf66ff536a2e.svg";
export { ForwardRef as ReactComponent };